function DatabasesView({ NOCODB_URL, AIRTABLE_BASE_URL, VAULTWARDEN_URL, canOpenAirtable }) {
  return (
    <section className="db-shortcuts-panel db-shortcuts-view" data-ui-view="databases" data-ui-section="databases-view">
      <div>
        <p className="eyebrow">Accesos directos</p>
        <h3>Enlaces relevantes</h3>
        <p>Abre rápidamente las plataformas operativas clave del equipo.</p>
      </div>
      <div className="db-shortcuts-grid" data-ui-section="databases-actions">
        <a className="btn ghost" href={NOCODB_URL} target="_blank" rel="noreferrer" data-ui-action="open-nocodb">
          Abrir NocoDB
        </a>
        {canOpenAirtable && (
          <a
            className="btn ghost"
            href={AIRTABLE_BASE_URL}
            target="_blank"
            rel="noreferrer"
            data-ui-action="open-airtable"
          >
            Abrir Airtable
          </a>
        )}
        <a
          className="btn ghost"
          href={VAULTWARDEN_URL}
          target="_blank"
          rel="noreferrer"
          data-ui-action="open-vaultwarden"
        >
          Abrir Vaultwarden
        </a>
      </div>
    </section>
  );
}

export default DatabasesView;
